import SeparateLine from '@/shared/Forms/SeparateLine'
import ParameterFormFields from '../../ParameterFormFields'
import css from './editParameterSidePageContent.module.css'
import { IParameter } from '@/pages/Parameters/parameters.types'
import useHttpLoader from '@/shared/hooks/useHttpLoader'
import useStateWithChange from '@/shared/hooks/useStateWithChange'
import parametersApi from '@/pages/Parameters/parameters.api'
import parameterEvents from '@/pages/Parameters/events/parameter/parameter.events.ts'
import Button from '@/shared/Buttons/Button'
import parametersUtils from '@/pages/Parameters/parameters.utils'

interface IProps {
  onCancel: () => void
  parameter: IParameter
}

const EditParameterSidePageContent = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const [parameter, _, handleChange] = useStateWithChange<IParameter>(props.parameter)

  const handleUpdateParameter = () => {
    wait(parametersApi.updateParameter(parameter), (resp) => {
      if (resp.status === 'success') {
        parameterEvents.updated(resp.body)
        props.onCancel()
      }
    })
  }

  return (
    <div className="flex-lines gap16" style={{ height: '100%' }}>
      <h4 className="text-heading-4">Редактирование</h4>
      <SeparateLine />
      <div className={css.wrapperContent}>
        <ParameterFormFields parameter={parameter} handleChange={handleChange} />
        <div className={css.actions}>
          <Button
            text="Сохранить"
            size="default"
            type="primary"
            loading={loading}
            disabled={!parametersUtils.isCorrectFormParameterFields(parameter)}
            onClick={handleUpdateParameter}
          />

          <Button size="default" type="default" text="Отменить" onClick={props.onCancel} disabled={loading} />
        </div>
      </div>
    </div>
  )
}

export default EditParameterSidePageContent
